import { render, staticRenderFns } from "./MyDiscounts.vue?vue&type=template&id=565059da&"
import script from "./MyDiscounts.vue?vue&type=script&lang=js&"
export * from "./MyDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports